import SidebarBookingsMessagesController from 'uplisting-frontend/pods/-sidebar/bookings/messages/controller';

export default class ProtectionOverviewBookingsMessagesController extends SidebarBookingsMessagesController {}
